import { render } from "./StarterProductSelection.vue?vue&type=template&id=3c34d9bc&scoped=true&ts=true"
import script from "./StarterProductSelection.vue?vue&type=script&lang=ts"
export * from "./StarterProductSelection.vue?vue&type=script&lang=ts"

import "./StarterProductSelection.vue?vue&type=style&index=0&id=3c34d9bc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c34d9bc"]])

export default __exports__